import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-light-layout',
    templateUrl: './light-layout.component.html',
    styleUrls: ['./light-layout.component.scss'],
    standalone: false
})
export class LightLayoutComponent implements OnInit {

  constructor() { }

  public ngOnInit() : void {
  }

}
